import React, { Component } from 'react';
import { Checkbox, Col, FormControl, FormGroup } from 'react-bootstrap';
import rest from 'rest';

import { REST_API_URL } from "../../Utils/Global";

/**
* Class RemoteRadioGroup
* Generic component to generate remote made radio
**/
class RemoteRadioGroup extends Component {

  /**
  * constructor
  * Constructor
  **/
  constructor(props) {
    super(props);
    this.state = {data: []};
  }

  /**
  * componentWillMount
  * Pre-rendering component function : loading fields to display
  **/
  componentWillMount() {
    rest({method: 'GET', path: REST_API_URL + this.props.path}).then(response => {
      let state = this.state;
      state.data = JSON.parse(response.entity);
      this.setState(state);
    });
  }

  /**
  * render
  * Rendering component function : display the radio group
  **/
  render() {
    if(this.state.data === undefined || this.state.data.length === 0) return null;

    const items = this.state.data.map((obj, index) => {
      let props = {
        name: this.getObjectProperty(this.props.idField, obj),
        onChange: this.handleCheck.bind(this),
        inline: true,
        defaultChecked: this.getObjectProperty(this.props.valueField, obj),
        disabled: this.props.readonly
      }

      //return <RemoteRadio {...props} />;
      return (
        <FormGroup key={this.getObjectProperty(this.props.idField, obj)}>
          <Col smOffset={2} sm={1}>
            <Checkbox {...props}>{this.getObjectProperty(this.props.labelField, obj)}</Checkbox>
          </Col>
          {this.getObjectProperty(this.props.valueField, obj) &&
            <Col sm={6}>
              <FormControl name={this.getObjectProperty(this.props.idField, obj)} onChange={this.handleCommentChange.bind(this)} componentClass="textarea" rows="5"
                value={this.getObjectProperty(this.props.commentField, obj)} disabled={this.props.readonly} />
            </Col>
          }
        </FormGroup>
      );
    });

    return (
      <div className="remoteCheckboxComment">
        {items}
      </div>
    );
  }

  /**
  * getObjectProperty
  * Returns the sub property value
  **/
  getObjectProperty(strProperties, object) {
    if(object === undefined) object = this.state.object;
    if(strProperties.indexOf(".") === -1) {
      return (object !== undefined && object[strProperties] !== undefined && object[strProperties] !== null) ? object[strProperties] : "";
    } else {
      let arrProperties = strProperties.split(".");
      const property = arrProperties.shift();
      object = object[property];
      return object ? this.getObjectProperty(arrProperties.join("."), object) : "";
    }
  }

  /**
  * setObjectProperty
  * Returns the object updated
  **/
  setObjectProperty(strProperties, value, object) {
    if(object === undefined) object = this.state.object;
    if(strProperties.indexOf(".") === -1) {
      object[strProperties] = value;
      return object;
    } else {
      let arrProperties = strProperties.split(".");
      const property = arrProperties.shift();
      object[property] = this.setObjectProperty(arrProperties.join("."), value, object[property]);
      return object;
    }
  }

  /**
  * handleCheck
  * Handle checkbox value change
  **/
  handleCheck(event) {
    let state = this.state;
    state.data = state.data.map((item) => {
      if(this.getObjectProperty(this.props.idField, item) === parseInt(event.target.name, 10)) {
        this.setObjectProperty(this.props.valueField, event.target.checked, item);

        if(event.target.checked === false) {
          this.setObjectProperty(this.props.commentField, null, item);
        }
      }

      return item;
    });

    this.setState(state);
  }

  /**
  * handleCommentChange
  * Handle comment value change
  **/
  handleCommentChange(event) {
    let state = this.state;
    state.data = state.data.map((item) => {
      if(this.getObjectProperty(this.props.idField, item) === parseInt(event.target.name, 10))
        this.setObjectProperty(this.props.commentField, event.target.value, item);

      return item;
    });

    this.setState(state);
  }

  /**
  * getData
  * Returns the data
  **/
  getData() {
    return this.state.data;
  }

}

export default RemoteRadioGroup;



// WEBPACK FOOTER //
// ./src/views/Helper/RemoteCheckboxComment.js